import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Button } from '../../components/ui/Button';
import { Route } from '../../components/layout/ProtectedLayout';

export type SettingsItem = { key: string; name: string };

type Props = {
  navigate: (r: Route) => void;
};

const SettingsListPage: React.FC<Props> = ({ navigate }) => {
  const [items, setItems] = useState<SettingsItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get<SettingsItem[]>('/admin/api/settings');
        setItems(res);
      } catch (e: any) {
        setError(e.message || 'Failed to load settings');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="max-w-2xl">
      <h1 className="mb-4 text-xl font-semibold">Settings</h1>
      {loading && <div>Loading...</div>}
      {error && <div className="text-sm text-destructive">{error}</div>}
      <div className="divide-y rounded-md border">
        {items.map(it => (
          <div key={it.key} className="flex items-center justify-between p-3">
            <div>{it.name}</div>
            <div className="flex gap-2">
              <Button size="sm" variant="outline" onClick={() => navigate({ name: 'settings/payment/view' as any })}>View</Button>
              <Button size="sm" onClick={() => navigate({ name: 'settings/payment' as any })}>Update</Button>
            </div>
          </div>
        ))}
        {!items.length && !loading && <div className="p-3 text-sm text-muted-foreground">No settings available</div>}
      </div>
    </div>
  );
};

export default SettingsListPage;
